module.exports = __webpack_public_path__ + "static/media/Bills_header_home.cb373e88.svg";